<template>
  <div class="geral-root">
    <div class="search-and-filter">
      <div class="search-bar">
        <search-bar
          :onSearch="debouncedOnSearch"
          tooltipLabel="informacao-campo-busca-parametrizacao-geral"
        />
      </div>

      <div class="replicapda-select">
        <vss-select
          class="selecione-categoria"
          title="selecione-categoria"
          :options="categorias"
          v-model="categoria"
          @onBlurFunction="onCategoriaChanged"
          tooltipLabel="informacao-campo-categoria-parametrizacao"
          :height="40"
        />
      </div>
    </div>

    <div class="registry-wrapper">
      <div class="table-scroll-area">
        <loading :isLoading="isLoading" />

        <div v-if="isEmpty" class="empty-wrapper">
          <empty-table-message />
        </div>

        <b-table
          v-else
          responsive
          :data="parametrizacoes"
          class="data-table data-table-label-word-wrap"
          backend-sorting
        >
          <b-table-column
            v-for="(f, i) in fields"
            :key="i"
            :field="f.key"
            :label="f.key != 'editar' ? $t(f.key) : ''"
            :width="f.width"
            :sortable="f.sortable"
            :custom-sort="f.sortFn"
            v-slot="props"
          >
            <div
              v-if="
                f.key !== 'editar' &&
                f.key !== 'valor' &&
                f.key !== 'video_url_parametrizacao'
              "
              class="text-descricoes-lower block-with-text"
            >
              <span>{{ props.row[f.key] }}</span>
            </div>

            <div
              v-else-if="
                f.key === 'editar' &&
                props.row.version_has_config === true &&
                permissao.update
              "
            >
              <b-button
                icon-left="pencil"
                type="is-primary"
                style="
                  border-radius: 6px;
                  min-width: 40px;
                  min-height: 40px;
                  margin-top: 9px;
                "
                size="is-small"
                @click="showModal(props.row)"
                v-tippy
                :title="$t('editar')"
              />
            </div>

            <div v-else-if="f.key === 'valor'">
              <div class="text-descricoes-upper">
                {{ props.row[f.key] }}
              </div>
            </div>

            <div
              v-else-if="
                f.key === 'editar' &&
                props.row.version_has_config === false &&
                permissao.create
              "
            >
              <b-button
                icon-left="check"
                type="is-success"
                style="
                  border-radius: 6px;
                  min-width: 40px;
                  min-height: 40px;
                  margin-top: 9px;
                "
                size="is-small"
                @click="showModal(props.row)"
                v-tippy
                :title="$t('config-nao-habilitada')"
              />
            </div>

            <div
              v-else-if="
                f.key === 'video_url_parametrizacao' &&
                props.row['video_url_parametrizacao']
              "
            >
              <div @click="showModalVideo(props.row)">
                <b-icon
                  icon="video"
                  type="is-primary"
                  style="margin-top: 13px"
                  size="is-medium"
                  class="is-medium is-clickable"
                  v-tippy
                  :title="$t('informacao-video-parametrizacao')"
                />
              </div>
            </div>
          </b-table-column>
        </b-table>

        <b-modal :active.sync="isShowingParametrizacao">
          <ParametrizacaoModal
            @fecharModal="closeModal"
            @refresh="realoadTela"
            :parametrizacao="parametrizacao"
          />
        </b-modal>

        <b-modal :active.sync="isShowingParametrizacaoVideo" width="680">
          <div class="bg">
            <ParametrizacaoModalVideo
              @fecharModal="closeModal"
              :parametrizacao="parametrizacao"
            />
          </div>
        </b-modal>
      </div>

      <PaginationViewer
        class="pagination-footer"
        :resetPagination="pagination.resetPagination"
        :totalItems="pagination.totalRows"
        :perPageOptions="pagination.perPageOptions"
        :optionStarted="pagination.optionStarted"
        @change="updatePagination"
      />
    </div>
  </div>
</template>

<script>
import ParametrizacaoService from "@/services/ParametrizacaoService";
import CategoriaConfigService from "@/services/CategoriaConfigService";
import ParametrizacaoModal from "@/components/conta/parametrizacoes/modal/ParametrizacaoModal";
import ParametrizacaoModalVideo from "@/components/conta/parametrizacoes/modal/ParametrizacaoModalVideo";

export default {
  components: {
    ParametrizacaoModal,
    ParametrizacaoModalVideo,
  },
  props: {
    permissao: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      fields: [
        {
          key: "label-tabela-usuario",
          width: 140,
          sortable: false,
          sortFn: null,
        },
        { key: "valor", width: 120, sortable: false, sortFn: null },
        { key: "descricao", width: null, sortable: false, sortFn: null },
        {
          key: "video_url_parametrizacao",
          width: null,
          sortable: false,
          sortFn: null,
        },
        { key: "editar", width: 20, sortable: false, sortFn: null },
      ],
      pagination: {
        resetPagination: false,
        perPageOptions: [10, 25, 50, 100],
        optionStarted: 0,
        perPage: null,
        totalRows: 0,
        currentPage: 1,
      },
      isLoading: false,
      isEmpty: false,
      msgs: [],
      parametrizacoes: [],
      parametrizacao: {},
      service: new ParametrizacaoService(this.$http, this.$router),
      serviceCategoriaConfig: new CategoriaConfigService(
        this.$http,
        this.$router
      ),
      categorias: [{ id: 0, label: this.$t("todos") }],
      categoria: { id: 0, label: this.$t("todos") },
      debouncedOnSearch: null,
      queryFilter: "",
      isShowingParametrizacao: false,
      isShowingParametrizacaoVideo: false,
      delete: null,
      situacoes: [
        { id: 2, label: "Todos" },
        { id: 1, label: "Ativos" },
        { id: 0, label: "Inativos" },
      ],
      situacao: { id: 2, label: "Todos" },
      changeThis: {},
    };
  },
  created() {
    this.pagination.perPage =
      this.pagination.perPageOptions[this.pagination.optionStarted];

    this.debouncedOnSearch = this.debounce(this.onSearch.bind(this), 500);
    this.carregarDados();
    this.carregarCategorias();
  },
  methods: {
    onSearch(value) {
      this.queryFilter = value;
      this.pagination.currentPage = 1;
      this.carregarDados(this.pagination.currentPage);
    },
    updatePagination(value) {
      this.pagination.resetPagination = false;
      this.pagination.perPage = value.perPage;
      this.pagination.currentPage = value.currentPage;
      this.carregarDados(value.currentPage);
    },
    carregarDados(currentPage = 1) {
      if (currentPage == 1 && this.pagination.currentPage != 1)
        this.pagination.resetPagination = true;

      this.isLoading = true;
      this.service
        .findAll(
          currentPage - 1,
          this.pagination.perPage,
          this.situacao.id,
          this.categoria.id,
          this.queryFilter ? this.queryFilter : ".*"
        )
        .then(this.mapItems)
        .then((value) => {
          this.parametrizacoes = value;
          this.isEmpty = this.parametrizacoes.length <= 0;
        })
        .catch((e) => {
          this.isEmpty = true;
          this.$root.showMessage("error", "msg-erro-load");
          console.error("Erro ao carregar parametrizações.");
        })
        .finally((_) => {
          this.isLoading = false;
          this.pagination.resetPagination = false;
        });
    },
    mapItems(body) {
      this.pagination.totalRows = body.totalElements;

      return body.content.map((m) => {
        return {
          idconfig: m.idconfig,
          idcategoriaconfig: m.idcategoriaconfig,
          nome: m.nome,
          "label-tabela-usuario": m.label,
          descricao: m.descricao,
          valor: this.jsonFormatter(m.tipo, m.valor, m.nome),
          tipo: m.tipo,
          video_url_parametrizacao: m.video_url,
          version_has_config: m.version_has_config,
          situacao: m.situacao,
        };
      });
    },
    jsonFormatter(tipo, valor, nome) {
      if (tipo) {
        let json = JSON.parse(tipo);
        if (json.type === "select") {
          let retorno = json.options.filter((e) => {
            if (e.value === valor) {
              return e.name;
            }
          });
          if (retorno.length > 0) {
            return retorno[0].name;
          } else {
            let correcao = {
              nome: nome,
              valor: json.options[0].value,
            };
            this.service.corrigeValor(correcao);
            return json.options[0].name;
          }
        } else {
          return valor;
        }
      } else {
        return valor;
      }
    },
    onCategoriaChanged() {
      this.carregarDados(this.pagination.currentPage);
    },
    carregarCategorias() {
      this.serviceCategoriaConfig
        .findAllCombo("")
        .then((value) => {
          if (value.status === 200) {
            if (value.content) {
              value.content.map((e) => {
                this.categorias.push({
                  id: e.idcategoriaconfig,
                  label: e.nome,
                });
              });
            }
          } else {
            this.categorias = [];
            this.categoria = {};
            this.$root.showMessage("error", "msg-erro-load", true);
          }
        })
        .catch((e) => {
          this.categorias = [];
          this.categoria = {};
          console.error(e);
        });
    },
    showModal(parametrizacao) {
      this.isShowingParametrizacao = !this.isShowingParametrizacao;
      this.parametrizacao = parametrizacao;
    },
    showModalVideo(parametrizacao) {
      this.isShowingParametrizacaoVideo = !this.isShowingParametrizacaoVideo;
      this.parametrizacao = parametrizacao;
    },
    realoadTela() {
      this.isShowingParametrizacao = !this.isShowingParametrizacao;
      this.carregarDados(this.pagination.currentPage);
      this.$root.showMessage("success", "sucesso-edit-parametrizacao", true);
    },
    closeModal(val) {
      if (val === "edit") {
        this.isShowingParametrizacao = !this.isShowingParametrizacao;
      } else {
        this.isShowingParametrizacaoVideo = !this.isShowingParametrizacaoVideo;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.geral-root {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.search-and-filter {
  flex-shrink: 0;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin: 10px 0;
  column-gap: 10px;

  .search-bar {
    width: 50%;
    min-width: 0;
    padding-right: 10px;
  }

  .replicapda-select {
    width: 50%;
    min-width: 0;

    div {
      height: 40px;
    }
  }
}

@media (max-width: 760px) {
  .search-and-filter {
    flex-wrap: wrap;

    .search-bar {
      width: 100%;
      padding-right: 0 !important;
    }

    .replicapda-select {
      width: 100% !important;
    }
  }

  .descricao-tabela-parametrizacao {
    font-size: 8px;
  }
}

/* ÁREA QUE SEGURA LISTA + PAGINAÇÃO */
.registry-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.empty-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}

.table-scroll-area {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.pagination-footer {
  flex-shrink: 0;
  margin-top: 8px;
}

.text-descricoes-lower {
  font-size: 14px;
  letter-spacing: -0.6px;
  word-spacing: -0.2px;
  font-weight: 400;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: lowercase;
}

.text-descricoes-upper {
  font-size: 14px;
  letter-spacing: -0.6px;
  word-spacing: -0.2px;
  font-weight: 400;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: uppercase;
}

.block-with-text {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
